module.exports = __webpack_public_path__ + "static/media/image21.7edad1a8.png";